import { render, staticRenderFns } from "./crudInstancesSystemOthers.vue?vue&type=template&id=fa8f98d6&"
import script from "./crudInstancesSystemOthers.vue?vue&type=script&lang=js&"
export * from "./crudInstancesSystemOthers.vue?vue&type=script&lang=js&"
import style0 from "./crudInstancesSystemOthers.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports